var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShopfloAssistant = function SvgShopfloAssistant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shopflo-assistant_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#shopflo-assistant_svg__b)",
    d: "M0 3.913A3.913 3.913 0 0 1 3.913 0h6.174A3.913 3.913 0 0 1 14 3.913v6.174A3.913 3.913 0 0 1 10.087 14H3.913A3.913 3.913 0 0 1 0 10.087z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#shopflo-assistant_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#shopflo-assistant_svg__d)",
    d: "m8.902 3.74-3.08 3.08a1.516 1.516 0 0 1-2.144-2.142l2.01-2.008a1.516 1.516 0 0 1 2.143 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#shopflo-assistant_svg__e)",
    d: "m8.902 3.74-3.08 3.08a1.516 1.516 0 0 1-2.144-2.142l2.01-2.008a1.516 1.516 0 0 1 2.143 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#shopflo-assistant_svg__f)",
    d: "m4.765 9.76 3.08-3.079A1.516 1.516 0 0 1 9.99 8.823l-2.01 2.008a1.516 1.516 0 0 1-2.142 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#shopflo-assistant_svg__g)",
    d: "m4.765 9.76 3.08-3.079A1.516 1.516 0 0 1 9.99 8.823l-2.01 2.008a1.516 1.516 0 0 1-2.142 0z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shopflo-assistant_svg__b",
    x1: 15.014,
    x2: 7,
    y1: 15.572,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18181B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28282B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shopflo-assistant_svg__d",
    x1: 6.017,
    x2: 7.191,
    y1: 1.517,
    y2: 5.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4760FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01CCA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shopflo-assistant_svg__e",
    x1: 7.876,
    x2: 11.398,
    y1: 7.778,
    y2: 5.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4760FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#4760FF",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4760FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shopflo-assistant_svg__f",
    x1: 6.017,
    x2: 7.191,
    y1: 1.517,
    y2: 5.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4760FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01CCA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shopflo-assistant_svg__g",
    x1: 7.876,
    x2: 11.398,
    y1: 7.778,
    y2: 5.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4760FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#4760FF",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4760FF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shopflo-assistant_svg__a",
    width: 14,
    height: 14,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 0.391,
    result: "effect1_innerShadow_16771_837"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_16771_837"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 0.196,
    result: "effect2_innerShadow_16771_837"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0941176 0 0 0 0 0.0941176 0 0 0 0 0.105882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_16771_837",
    result: "effect2_innerShadow_16771_837"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shopflo-assistant_svg__c",
    width: 9.351,
    height: 12.373,
    x: 2.06,
    y: 1.053,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.174
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.489
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16771_837"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.391,
    dy: -0.391
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.391
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.243341 0 0 0 0 0.243341 0 0 0 0 0.255258 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_16771_837",
    result: "effect2_dropShadow_16771_837"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_16771_837",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.293
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect3_innerShadow_16771_837"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.098
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_innerShadow_16771_837",
    result: "effect4_innerShadow_16771_837"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.391,
    dy: 0.391
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.587
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.34 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect4_innerShadow_16771_837",
    mode: "plus-lighter",
    result: "effect5_innerShadow_16771_837"
  })))));
};
export default SvgShopfloAssistant;